import { noop } from 'lodash-es'

import { LayerToggle } from './LayerToggle'
import { useTrafficLayer } from './useTrafficLayer'

export type TrafficLayerToggleProps = {
  value?: boolean
  onValueChange?: (value: boolean) => void
}

export const TrafficLayerToggle = ({
  value = false,
  onValueChange = noop,
}: TrafficLayerToggleProps) => {
  const { traffic, toggleTraffic } = useTrafficLayer(value, onValueChange)

  return (
    <LayerToggle
      name="Traffic"
      value={traffic}
      setValue={toggleTraffic}
      testId="layer-manager-traffic-toggle"
    />
  )
}
